import axios from 'axios'

export default {
    getLinkContent(){
        return axios.get('/linkcontent?is_active=1')
            .then(response => {
                return response.data
            })
    },
    getLinkContentDataSource(params){
        return axios.get('/linkcontent/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getLinkContentbyID(id){
        return axios.get('/linkcontent/' + id)
            .then(response => {
                return response.data
            })
    },    
    createLinkContent(formdata){
        return axios.post('/linkcontent', formdata)
            .then(response => {
                return response.data
            })
    },
    updateLinkContent(id,formdata){
        return axios.post('/linkcontent/' + id + '/update', formdata  )
            .then(response => {
                return response.data
            })
    },
    deactivateLinkContent(id){
        return axios.put('/linkcontent/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateLinkContent(id){
        return axios.put('/linkcontent/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    destroyLinkContent(id){
        return axios.delete('/linkcontent/' + id)
            .then(response => {
                return response.data
            })
    },
    getLinkContentOrderList(params){
        return axios.get('/linkcontent/orderlist', {params})
            .then(response => {
                return response.data
            })
    },
    updateLinkContentOrderList(formdata){
        return axios.post('/linkcontent/updatelist', formdata)
            .then(response => {
                return response.data
            })
    },   
    updateBGImage(formdata){
        return axios.post('/linkcontent'  + id + '/update_image', formdata)
            .then(response => {
                return response.data
            })
    }, 
}